export var pickerUtils = {
  methods: {
    mapNavigationKeys: function mapNavigationKeys(key) {
      if (key.key === 'Escape') {
        this.$refs.select.hidePopup();
      }

      if (key.key === 'ArrowDown') {
        var offset = 1;

        if (this.$refs.select.optionIndex === this.$refs.select.options.length - 1) {
          offset = 2;
        }

        this.$refs.select.moveOptionSelection(offset);
      }

      if (key.key === 'ArrowUp') {
        var _offset = 1;

        if (this.$refs.select.optionIndex === 0) {
          _offset = 2;
        }

        this.$refs.select.moveOptionSelection(-_offset);
      }

      if (key.key === 'Enter' || key.key === 'Tab') {
        // select the focused option
        if (this.$refs.select.options[this.$refs.select.optionIndex].type !== 'empty-option') {
          this.$refs.select.toggleOption(this.$refs.select.options[this.$refs.select.optionIndex]);
        }
      }
    }
  }
};